import type { CSSProperties } from 'react';

import type { Preference } from '@/signupElement/Signup.types';

import BooleanInputs from './BooleanInputs';
import MultipleChoice from './MultipleChoice';
import Select from './Select';
import TextInput from './TextInput';

interface Props {
  data: Preference[];
  style: CSSProperties;
  isLabelVisible?: boolean;
}

const AdditionalFields = ({ data, style, isLabelVisible }: Props) => {
  return (
    <>
      {data.map((preference) => (
        <AdditionalField key={preference.id} preference={preference} style={style} isLabelVisible={isLabelVisible} />
      ))}
    </>
  );
};

interface AdditionalFieldProps {
  preference: Preference;
  style: CSSProperties;
  isLabelVisible?: boolean;
}

const AdditionalField = ({ preference, style, isLabelVisible }: AdditionalFieldProps) => {
  switch (preference.preference_type) {
    case 'text':
      return <TextInput style={style} preference={preference} isLabelVisible={isLabelVisible} />;
    case 'phone_number':
      return <TextInput style={style} preference={preference} type="tel" isLabelVisible={isLabelVisible} />;
    case 'multiple_choice':
      return <MultipleChoice preference={preference} />;
    case 'boolean':
      return <BooleanInputs preference={preference} />;
    case 'dropdown':
      return <Select style={style} preference={preference} isLabelVisible={isLabelVisible} />;
    default:
      return null;
  }
};

export default AdditionalFields;
